import { withWindow } from '@shared/utils/withWindow';
import { allowedDomains } from './safeLinkAllowedDomains';
import { ensureHttpsPrefix } from '@shared/utils/urlHelpers';

const EVENT_URL_PREFIX = '/event/';

export const getIsAllowListedUrl = (href: string) => {
  let isAllowListed = false;

  if (href) {
    let url: URL | undefined;
    try {
      url = new URL(ensureHttpsPrefix(href.trim()));
    } catch (_e) {
      // Invalid href, assume URL is not allowlisted
    }

    if (url) {
      const domainParts = url.hostname.toLowerCase().split('.');
      const maxDomainPartsToCheck = Math.min(domainParts.length, 4);
      for (let i = 1; i <= maxDomainPartsToCheck; i++) {
        const domainToCheck = domainParts.slice(-i).join('.');
        if (allowedDomains.has(domainToCheck)) {
          isAllowListed = true;
          break;
        }
      }
    }
  }
  return isAllowListed;
};

/**
 * Converts a relative /event/* URL into an absolute URL
 * using the given current event handle.
 *
 * @param {string} url - The input URL (could be relative or absolute).
 * @param {string} currentEventHandle - The current event handle (e.g., "johnandjane").
 * @returns {string} - The converted absolute URL (or original if no match).
 */
export const convertEventUrl = (url: string, currentEventHandle?: string) => {
  const trimmedUrl = url.trim();
  if (!currentEventHandle || !trimmedUrl.startsWith(EVENT_URL_PREFIX)) {
    return ensureHttpsPrefix(trimmedUrl);
  }
  const formattedUrl = withWindow(global => `${global.location.origin}/${currentEventHandle}/${trimmedUrl.substring(EVENT_URL_PREFIX.length)}`, '');

  return formattedUrl;
};
